import { Button } from "components/Button/Button";
import { Input, TextArea } from "components/Form";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { addUPSCQuestion } from "../../services/aiintegraion";
import "./EvaluateUPSCQuestion.css"

export default function EvaluateQuestion() {
    const navigate = useNavigate();
    const [data, setData] = useState({
        questionType: "",
        question: "",
        answer: "",
    });
    const [errorField, setErrorField] = useState({});
    const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
    const [responseResult, setResponseResult] = useState(null);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);


    const questionTypeOptions = [
        { value: "GS", label: "GS" },
        { value: "Essay", label: "Essay" },
    ];

    const handleValidation = () => {
        let isError = false;
        const newErrorField = {};

        if (!data.questionType) {
            newErrorField.questionType = "Please select a question type";
            isError = true;
        }
        if (!data.question) {
            newErrorField.question = "Please enter the question";
            isError = true;
        }
        if (!data.answer) {
            newErrorField.answer = "Please enter the answer";
            isError = true;
        }

        setErrorField(newErrorField);
        return !isError;
    };

    const handleAdd = async () => {
        try {
            if (handleValidation()) {
                setSubmitLoading(true);
                setIsLoading(true); // Start loader
                const res = await addUPSCQuestion(data);
                setSubmitLoading(false);
                setIsLoading(false); // Stop loader


                if (res.code === 200) {
                    toast.success(res.message || "Submitted successfully");
                    setResponseResult(parseResponse(res.data));
                    setIsSubmitted(true);
                } else {
                    toast.error(res.message || "Submission failed");
                }
            }
        } catch (e) {
            setSubmitLoading(false);
            toast.error("Failed to submit question");
        }
    };

    const parseResponse = (text) => {
        const feedback = text.match(/📝 Feedback:\n([\s\S]*?)\n\n✅/);
        const suggestions = text.match(/✅ Suggestions:\n([\s\S]*?)\n\n📊/);
        const scoreMatch = text.match(/📊 Estimated Score:\s*(.*)/);

        const score = scoreMatch?.[1]?.trim() || "No score found";

        // Extract content after the score
        let extraContent = "";
        if (scoreMatch?.index !== undefined) {
            const scoreEndIndex = scoreMatch.index + scoreMatch[0].length;
            extraContent = text.slice(scoreEndIndex).trim();
        }

        return {
            feedback: feedback?.[1]?.trim() || "No feedback found",
            suggestions: suggestions?.[1]?.trim() || "No suggestions found",
            score,
            extraContent: extraContent || "No extra content found",
        };
    };


    return (
        <div style={{ minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center", background: "#f0f4f8", padding: 20 }}>
            {!isSubmitted ? (
                <div style={{ width: "100%", maxWidth: "600px", background: "#fff", padding: "30px", borderRadius: "10px", boxShadow: "0 0 10px rgba(0,0,0,0.1)" }}>
                    <div className="d-flex align-items-center mb-4">
                        <h4 className="mb-0">Evaluate UPSC Question</h4>
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Question Type</label>
                        <select
                            className="form-control"
                            value={data.questionType}
                            onChange={(e) => setData({ ...data, questionType: e.target.value })}
                        >
                            <option value="">Select a type</option>
                            {questionTypeOptions.map((opt) => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                        </select>
                        {errorField.questionType && <div className="text-danger">{errorField.questionType}</div>}
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Question</label>
                        <TextArea
                            type="text"
                            name="question"
                            className="form-control"
                            placeholder="Enter the question"
                            value={data.question}
                            onChange={(e) => setData({ ...data, question: e.target.value })}
                            error={errorField.question}
                            required
                            rows={2}
                        />
                    </div>

                    <div className="mb-4">
                        <label className="form-label">Answer</label>
                        <TextArea
                            type="text"
                            name="answer"
                            className="form-control"
                            placeholder="Enter the answer"
                            value={data.answer}
                            onChange={(e) => setData({ ...data, answer: e.target.value })}
                            error={errorField.answer}
                            required
                            rows={3}
                        />
                    </div>

                    <div className="text-center mb-4">
                        <Button onClick={handleAdd} {...submitButtonElement}>
                            Submit
                        </Button>
                    </div>
                </div>
            ) : (
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "stretch",
                    background: "#ffffff",
                    borderRadius: "20px",
                    boxShadow: "0 5px 25px rgba(0,0,0,0.1)",
                    padding: "40px",
                    maxWidth: "1250px",
                    width: "100%",
                }}>
                    <div style={{
                        flex: 1,
                        background: "linear-gradient(to right, #ff6a6a, #c0392b)",
                        color: "white",
                        borderRadius: "15px",
                        padding: "10px 15px 10px 15px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center"
                    }}>
                        <h2 style={{ fontSize: "25px", fontWeight: "bold", marginTop: "12px" }}>🎉 Thank you for submitting!</h2>
                        <p style={{ fontSize: "16px", marginTop: "10px" }}>Below are your evaluated results. Great effort!</p>
                    </div>
                    <br />
                    <div style={{ flex: 2, paddingLeft: "30px", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                        <div>
                            <h4 className="mb-2">📝 Feedback</h4>
                            <p style={{ whiteSpace: "pre-wrap", marginBottom: "20px" }}>{responseResult.feedback}</p>

                            <h4 className="mb-2">✅ Suggestions</h4>
                            <p style={{ whiteSpace: "pre-wrap", marginBottom: "20px" }}>{responseResult.suggestions}</p>

                            <h4 className="mb-2">📊 Estimated Score</h4>
                            <p>{responseResult.score}</p>
                            {responseResult.extraContent && (
                                <>
                                    <p style={{ whiteSpace: "pre-wrap", marginBottom: "20px" }}>
                                        {responseResult.extraContent}
                                    </p>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            )}
            {isLoading && (
                <div style={{
                    position: 'fixed',
                    top: 0, left: 0,
                    width: '100%', height: '100%',
                    background: 'rgba(255, 255, 255, 0.85)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999,
                    flexDirection: 'column'
                }}>
                    <div style={{ fontSize: "20px", fontWeight: 500, marginBottom: "20px", color: "#333" }}>
                        Let's check your score !
                    </div>
                    <div className="smooth-dot-loader">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            )}


        </div>
    );
}
